import { IDefineCommand } from 'core-ts-types';
import { INotificationDelegate } from '../../../../global/helpers/notification_delegate';
angular
  .module('capability-ng-academic-planner')
  .service(
    'saveTermPreviewPlanCommand',
    (
      $http: ng.IHttpService,
      log: any,
      defineCommand: IDefineCommand,
      ngAPNotificationDelegate: INotificationDelegate
    ) =>
      defineCommand('saveTermPreviewPlanCommand', (deferred, termPlan) =>
        // mock/auto_load_term_preview.json
        $http
          .put(`academicplan/quickplan/`, termPlan)
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngAPNotificationDelegate.success(`Updated your plan with template`);
            deferred.resolve(data);
          })
          .catch((e) => {
            ngAPNotificationDelegate.error(`Failed to update your plan with new template: ${e.data.detail}`);
            log.error(e);
            deferred.reject(e);
          })
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/commands/save_term_preview_plan_command.ts